export default function getRatio() {
    return window.devicePixelRatio ? window.devicePixelRatio : 2;
}
//# sourceMappingURL=get-ratio.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/dom-util/esm/get-ratio.js
// module id = null
// module chunks = 